export const pluralMappings = {
  company: {
    '=1': 'company',
    other: 'companies',
  },
  credit: {
    '=1': 'credit',
    other: 'credits',
  },
  user: {
    '=1': 'user',
    other: 'users',
  },
  individual: {
    '=1': 'individual',
    other: 'individuals',
  },
  team: {
    '=1': 'team',
    other: 'teams',
  },
  field: {
    '=1': 'field',
    other: 'fields',
  },
  record: {
    '=1': 'record',
    other: 'records',
  },
};
